// extracted by mini-css-extract-plugin
module.exports = {"base":"CoachInvoiceReport_base__3WQAL","printSection":"CoachInvoiceReport_printSection__231uK"};